"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const AkSpinner = require("@atlaskit/spinner").default;
const button_1 = __importDefault(require("@atlaskit/button"));
const form_context_1 = require("./form-context");
class FormButton extends React.Component {
    render() {
        return (React.createElement(form_context_1.FormContext.Consumer, null, ({ isSubmitting }) => (React.createElement(button_1.default, Object.assign({}, this.props, { iconBefore: isSubmitting && this.props.type === "submit" ? (React.createElement(AkSpinner, { size: "small", isCompleting: false })) : (undefined), isDisabled: isSubmitting })))));
    }
}
exports.FormButton = FormButton;
